export default "__VITE_ASSET__HDu9w7_h__"